<template lang="pug">
.change-container
  couponOpenedItems(:item="groups.beforeProperty" :type="typeSbefore").left-coupon
  couponOpenedItems(:item="groups.afterProperty" :type="typeSAfter").right-coupon
  img.arrow(src="https://m.hellobike.com/resource/gallery/61/KJkM6l2k_Rectangle%20429.png?x-oss-process=image/quality,q_80")
</template>
<script>

import couponOpenedItems from './coupon-opened-items.vue';

export default {
  components: {
    couponOpenedItems,
  },
  props: {
    groups: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      typeSbefore: 0,
      typeSAfter: 0,
    };
  },
  computed: {
  },
  mounted() {
    this.getType();
  },
  methods: {
    // extendPropType 3变更 4 变更 2后置膨胀
    getType() {
      if (this.groups.beforeProperty.extendPropType === 3
      || this.groups.beforeProperty.extendPropType === 4) {
        this.typeSbefore = 1;
        this.typeSAfter = 2;
      }
      if (this.groups.beforeProperty.extendPropType === 2) {
        this.typeSbefore = 3;
        this.typeSAfter = 4;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.change-container {
  display: flex;
  position: relative;

  .left-coupon {
    opacity: 0.7;
    margin-right: 0.02rem;
    width: 0.77rem;
    height: 0.92rem;
  }

  .right-coupon {
    width: 0.77rem;
    height: 0.92rem;
  }

  img.arrow {
    position: absolute;
    width: 0.22rem;
    height: 0.16rem;
    top: 0.37rem;
    left: 0.65rem;
  }
}
</style>
